import React from 'react';
import { ArrowUpRight, Clock } from 'lucide-react';

const posts = [
  {
    number: '01',
    category: 'PoSH & Culture',
    title: 'Why PoSH is your boardroom\u2019s most underrated asset.',
    excerpt:
      'A well-implemented PoSH framework does more than shield you from litigation \u2014 it becomes a quiet signal of the kind of enterprise you\u2019re building.',
    author: 'Krishnamurthy Hegde',
    date: 'Vol. I \u00b7 2025',
    read: '6 min read',
    image:
      'https://images.unsplash.com/photo-1716703742424-16bbc0d1fad3?auto=format&fit=crop&w=1200&q=80',
  },
  {
    number: '02',
    category: 'Fundraising',
    title: '5 blind spots that quietly kill your valuation before Series A.',
    excerpt:
      'From cap-table hygiene to KYC trails, the smallest oversights compound into the largest markdowns. Here\u2019s the pre-diligence checklist we run for every founder.',
    author: 'Manjunatha Hegde',
    date: 'Vol. I \u00b7 2025',
    read: '8 min read',
    image:
      'https://images.unsplash.com/photo-1756885465373-bce82fd5c944?auto=format&fit=crop&w=1200&q=80',
  },
  {
    number: '03',
    category: 'FEMA & Global',
    title: 'FEMA in 2025: what every cross-border business must re-learn.',
    excerpt:
      'With ODI/FDI thresholds and compounding norms in flux, cross-border compliance has quietly become a strategic decision \u2014 not a tax one.',
    author: 'Vijaya Rao',
    date: 'Vol. I \u00b7 2025',
    read: '10 min read',
    image:
      'https://images.unsplash.com/photo-1771244688590-1e481dba1b5a?auto=format&fit=crop&w=1200&q=80',
  },
];

const Blog = () => {
  return (
    <section id="blog" className="relative py-24 lg:py-36 bg-ivory overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-divider"></span>
              <span className="font-mono-label text-gold-dark">Insights</span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-[3.4rem] leading-[1.05] text-ink">
              Considered <span className="italic text-gold-dark">thinking</span> from the practice.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-center gap-3 text-muted-kmh">
            <Clock className="w-4 h-4 text-gold" />
            <span className="font-mono-label">Editorial · Volume I · 2025</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
          {posts.map((p) => (
            <a
              key={p.number}
              href="#contact"
              className="group bg-ivory hover:bg-paper card-lift flex flex-col"
            >
              <div className="img-zoom aspect-[4/3] relative">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                <span className="absolute top-4 left-4 font-mono-label text-ivory bg-ink/70 backdrop-blur-sm px-3 py-1.5">
                  {p.category}
                </span>
                <span className="absolute top-4 right-4 w-10 h-10 rounded-full bg-ivory/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <ArrowUpRight className="w-4 h-4 text-ink" />
                </span>
              </div>

              <div className="p-8 lg:p-10 flex-1 flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="font-mono-label text-gold">No. {p.number}</span>
                  <span className="font-mono-label text-muted-kmh">{p.read}</span>
                </div>

                <h3 className="font-serif-display text-xl lg:text-2xl text-ink leading-tight mt-6">
                  {p.title}
                </h3>
                <p className="font-sans-body text-sm text-muted-kmh leading-relaxed mt-4">
                  {p.excerpt}
                </p>

                <div className="mt-auto pt-8 border-t border-line flex items-center justify-between">
                  <div>
                    <p className="font-serif-display text-base text-ink">{p.author}</p>
                    <p className="font-mono-label text-muted-kmh mt-1">{p.date}</p>
                  </div>
                  <span className="link-underline font-mono-label text-ink">Read Essay</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
